module.exports = __webpack_public_path__ + "static/accommodation-4121c7a7caa885b99f2da2d041ded007.jpeg";